module.exports = __webpack_public_path__ + "static/media/window-frame.ee531562.svg";